import {useCallback, useMemo} from "react";
import {startOfToday} from "date-fns";

import {dateTimeFormat, formatDate, formatPL} from "@pg-mono/string-utils";

import {IRangeQuery} from "../../request/IRangeQuery";

export const useConstructionEndDate = () => {
    const today = useMemo(() => formatPL(startOfToday(), "yyyy-MM-dd"), []);

    const calculateConstructionEndDate = useCallback(
        (constructionEndDate: string | undefined | null, constructionDateRange: IRangeQuery<string> | undefined) => {
            if (constructionEndDate) {
                return constructionEndDate >= today ? formatDate(constructionEndDate, dateTimeFormat.quarter) : "Gotowe";
            }
            if (constructionDateRange) {
                return constructionDateRange.upper >= today ? formatDate(constructionDateRange.upper, dateTimeFormat.quarter) : "Gotowe";
            }
        },
        [today]
    );

    const isConstructionFinished = useCallback(
        (constructionEndDate: string | undefined | null, constructionDateRange: IRangeQuery<string> | undefined | null) => {
            const endDate = constructionEndDate || constructionDateRange?.upper;

            return endDate ? endDate < today : false;
        },
        [today]
    );

    return {
        calculateConstructionEndDate,
        isConstructionFinished
    };
};
import {useCallback, useMemo} from "react";
import {startOfToday} from "date-fns";

import {dateTimeFormat, formatDate, formatPL} from "@pg-mono/string-utils";

import {IRangeQuery} from "../../request/IRangeQuery";

export const useConstructionEndDate = () => {
    const today = useMemo(() => formatPL(startOfToday(), "yyyy-MM-dd"), []);

    const calculateConstructionEndDate = useCallback(
        (constructionEndDate: string | undefined | null, constructionDateRange: IRangeQuery<string> | undefined) => {
            if (constructionEndDate) {
                return constructionEndDate >= today ? formatDate(constructionEndDate, dateTimeFormat.quarter) : "Gotowe";
            }
            if (constructionDateRange) {
                return constructionDateRange.upper >= today ? formatDate(constructionDateRange.upper, dateTimeFormat.quarter) : "Gotowe";
            }
        },
        [today]
    );

    const isConstructionFinished = useCallback(
        (constructionEndDate: string | undefined | null, constructionDateRange: IRangeQuery<string> | undefined | null) => {
            const endDate = constructionEndDate || constructionDateRange?.upper;

            return endDate ? endDate < today : false;
        },
        [today]
    );

    return {
        calculateConstructionEndDate,
        isConstructionFinished
    };
};
